<template>
  <div class="login-page">
    <header class="login-header">
      <div class="header-content">
        <div class="logo-box">
          <img src="/logo.png" alt="Logo" class="logo-img" />
        </div>
        <h2 class="company-name">湖北省建筑劳务协会</h2>
      </div>
    </header>

    <main class="login-main">
      <div class="login-card">
        <!-- Left Side: Image -->
        <div class="login-card-left">
          <div class="bg-image" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuCHc_LSGssbqm8nvJ56BG5gGbqorwfiqkG-CMc37_VUh8vw_E-375Ff6pWMMOXtuMgEGWPmM85otE6YdJqzBTzKJsUsNA2sF2VW_VU7PnxYNIa1Ji_YH0dhKT63gllsenJ1y9MxpITg7DhaJs5QHL4uXDyvqVbd-rdqLLPdPHdFbNTh1q2FRTFqx_fOMPLf0M1AMWNABVK6AxMG240Pu0GrTyMQGP3p_MA0BsO3PAhbCDzurdZ8X321bUQPvp0oroztLr0Sbf5eYJo');"></div>
          <div class="bg-overlay"></div>
          <div class="bg-text">
            <h3>建设美好湖北</h3>
            <p>致力于提升全省建设行业劳动管理水平，服务会员，促进行业发展。</p>
          </div>
        </div>

        <!-- Right Side: Form -->
        <div class="login-card-right">
          <div class="form-header">
            <h1>会员登录</h1>
            <p>欢迎回来，请输入您的账号信息以继续。</p>
          </div>

          <form class="login-form">
            <div class="form-group">
              <label for="username">用户名</label>
              <div class="input-wrapper">
                <input 
                  id="username" 
                  type="text" 
                  v-model="loginForm.username" 
                  placeholder="请输入用户名" 
                  class="form-input"
                  ref="usernameInput"
                  @keydown.enter="focusPassword"
                />
                <div class="input-icon-left">
                  <!-- User Icon SVG -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon-svg">
                    <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="label-row">
                <label for="password">密码</label>
              </div>
              <div class="input-wrapper">
                <input 
                  id="password" 
                  :type="passwordVisible ? 'text' : 'password'" 
                  v-model="loginForm.password" 
                  placeholder="请输入密码" 
                  class="form-input"
                  ref="passwordInput"
                  @keydown.enter="submitForm"
                />
                <div class="input-icon-left">
                  <!-- Lock Icon SVG -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon-svg">
                    <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clip-rule="evenodd" />
                  </svg>
                </div>
                <button type="button" class="input-icon-right" @click="togglePassword">
                  <!-- Eye Icon SVG (Open/Close) -->
                  <svg v-if="passwordVisible" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon-svg">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                    <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clip-rule="evenodd" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon-svg">
                    <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                    <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                    <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Error Message -->
            <div v-if="loginFailed" class="error-message">
              {{ loginErrorMessage }}
            </div>

            <button type="button" class="submit-btn" @click="submitForm">
              立即登录
            </button>
          </form>
        </div>
      </div>
    </main>

    <footer class="login-footer">
      <p>© 2024 湖北省建筑劳务协会 版权所有</p>
      <p class="version-tag">Version: v1.1.20260429</p>
    </footer>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import userService from '@/api/user';

const router = useRouter();
const loginForm = reactive({
  username: '',
  password: ''
});

const usernameInput = ref(null);
const passwordInput = ref(null);
const loginFailed = ref(false);
const loginErrorMessage = ref('');
const passwordVisible = ref(false);

const togglePassword = () => {
  passwordVisible.value = !passwordVisible.value;
};

onMounted(() => {
  if (usernameInput.value) {
    usernameInput.value.focus();
  }
});

const focusPassword = () => {
  if (passwordInput.value) {
    passwordInput.value.focus();
  }
};

const submitForm = async () => {
  if (!loginForm.username || !loginForm.password) {
    loginFailed.value = true;
    loginErrorMessage.value = '请输入用户名和密码';
    return;
  }
  
  try {
    const userType = await userService.login(loginForm);
    if (userType === 'admin') {
      router.push('/admin/workbench');
    } else if (userType === 'user') {
      router.push('/user/home');
    }
  } catch (error) {
    loginFailed.value = true;
    loginErrorMessage.value = '账号或密码不正确，请重新输入。';
    console.error('Login failed:', error);
  }
};
</script>

<style scoped>
/* Reset & Base */
* {
  box-sizing: border-box;
}

.login-page {
  font-family: "Public Sans", "Noto Sans SC", sans-serif;
  background-color: #f6f6f8;
  color: #0f172a;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* Header */
.login-header {
  background-color: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.75rem 1.5rem;
}
@media (min-width: 1024px) {
  .login-header { padding: 0.75rem 2.5rem; }
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-box {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Removed background color for image logo */
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-svg {
  display: none;
}

.company-name {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
  color: #0f172a;
}

/* Main */
.login-main {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-card {
  width: 100%;
  max-width: 56rem;
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  min-height: 480px;
  overflow: hidden;
}
@media (min-width: 768px) {
  .login-card { flex-direction: row; }
}

/* Left Panel */
.login-card-left {
  position: relative;
  display: none;
  width: 100%;
  background-color: #f1f5f9;
}
@media (min-width: 768px) {
  .login-card-left { display: block; width: 50%; }
}

.bg-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(19, 91, 236, 0.4);
  mix-blend-mode: multiply;
}

.bg-text {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.6), transparent, transparent);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2rem;
  color: white;
}

.bg-text h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.bg-text p {
  font-size: 1rem;
  opacity: 0.9;
}

/* Right Panel */
.login-card-right {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 2.5rem;
}
@media (min-width: 768px) {
  .login-card-right { width: 50%; }
}

.form-header {
  margin-bottom: 1.5rem;
}

.form-header h1 {
  font-size: 1.75rem;
  font-weight: 900;
  color: #0f172a;
  margin-bottom: 0.5rem;
}

.form-header p {
  color: #64748b;
  font-size: 0.875rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #0f172a;
}

.input-wrapper {
  position: relative;
}

.form-input {
  display: flex;
  height: 3rem;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid #cbd5e1;
  background-color: #f6f6f8;
  padding-left: 2.75rem;
  padding-right: 1rem;
  font-size: 0.95rem;
  color: #0f172a;
  outline: none;
  transition: all 0.2s;
}

.form-input:focus {
  border-color: #135bec;
  box-shadow: 0 0 0 1px #135bec;
}

.input-icon-left {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  pointer-events: none;
}

.form-input:focus + .input-icon-left {
  color: #135bec;
}

.icon-svg {
  width: 1.25rem;
  height: 1.25rem;
}

.input-icon-right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  border: none;
  background: none;
  cursor: pointer;
}
.input-icon-right:hover {
  color: #475569;
}

.submit-btn {
  margin-top: 0.5rem;
  height: 3rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #135bec;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 6px -1px rgba(19, 91, 236, 0.2);
  transition: all 0.2s;
}

.submit-btn:hover {
  background-color: #1d4ed8;
}

.error-message {
  color: #ef4444;
  font-size: 0.875rem;
  text-align: center;
}

/* Footer */
.login-footer {
  padding: 1rem 0;
  text-align: center;
}


.login-footer p {
  font-size: 0.75rem;
  color: #94a3b8;
  margin: 0.25rem 0;
}

.version-tag {
  opacity: 0.5;
  font-size: 10px !important;
}

/* Hide default browser password toggle completely */
input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none !important;
}

/* Ensure padding so text doesn't hit the icon */
.form-input {
  padding-right: 3rem;
}
</style>
